import { useCallback } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallTwoLineWithTimerProps } from './types';
import { isNil, isNotNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';
import { ViewAllButton } from '../ViewAllButton';
import { useCountdown } from '../../../../hooks/useCountdown';
import { useOpenDeeplink } from '../../../../hooks';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';

export const HeadlineSmallTwoLineWithTimer = ({
  header,
  screen,
}: HeadlineSmallTwoLineWithTimerProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const handlePressViewAll = useCallback(() => {
    if (header?.item.deeplink) {
      logAnalyticsEvent({
        name: 'CLICK_HEADLINE_SMALL_TWO_LINE_MORE',
        analytics: {
          ...header.logging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: header.logging.ably_only_log,
      });
      openDeeplink(header.item.deeplink);
    }
  }, [
    openDeeplink,
    header?.item.deeplink,
    header?.logging,
    screen,
    logAnalyticsEvent,
  ]);

  const { timeText: timerText } = useCountdown(header?.item.timer?.finished_at);

  if (isNil(header)) return null;

  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row padding={{ top: 24, bottom: 16 }} alignItems="center">
      <Flex.Column
        gap={2}
        flex={1}
        padding={{ left: 16, right: hasDeeplink ? 0 : 16 }}
      >
        <Flex.Row gap={4} alignItems="center">
          <HTMLText type={'h5'} color={'content_primary'} numberOfLines={1}>
            {header.item.title}
          </HTMLText>
          {isNotNil(timerText) && (
            <Typography type="h5" color="content_pink_primary">
              {timerText}
            </Typography>
          )}
        </Flex.Row>
        {isNotNil(header.item.sub_title) && (
          <HTMLText type="body2" color="content_secondary">
            {header.item.sub_title}
          </HTMLText>
        )}
      </Flex.Column>

      {hasDeeplink && (
        <Flex padding={{ right: 4 }}>
          <ViewAllButton onPress={handlePressViewAll} />
        </Flex>
      )}
    </Flex.Row>
  );
};
